<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <b-tabs content-class="mt-3">
      <b-tab title="Estoque" active @click="changeTabSelected('stock')">
        <b-form v-if="tabSelected === 'stock'" @submit.prevent.stop="salvar">
          <b-form-group v-slot="{ ariaDescribedby }" label="Pesquisar por:">
            <b-form-radio-group
              id="input-group-tipo-pesquisa"
              v-model="tipoPesquisa"
              label-for="input-tipo-pesquisa"
            >
              <b-form-radio
                :aria-describedby="ariaDescribedby"
                name="rd-codigo"
                value="codigo"
                >Código</b-form-radio
              >
              <b-form-radio
                :aria-describedby="ariaDescribedby"
                name="rd-nome"
                value="nome"
                >Nome</b-form-radio
              >
            </b-form-radio-group>
          </b-form-group>
          <b-input-group label="Insumo">
            <b-form-input
              v-model="codigoInsumo"
              class="input-color"
              :placeholder="
                tipoPesquisa === 'codigo'
                  ? 'Digite o código do insumo'
                  : 'Digite o nome do insumo'
              "
              @keydown.enter.prevent="
                tipoPesquisa === 'codigo'
                  ? pesquisarInsumoId(codigoInsumo)
                  : pesquisarInsumoNome(codigoInsumo)
              "
            ></b-form-input>
            <b-input-group-append>
              <b-button
                style="background-color: #113d63"
                variant="info"
                @click="
                  tipoPesquisa === 'codigo'
                    ? pesquisarInsumoId(codigoInsumo)
                    : pesquisarInsumoNome(codigoInsumo)
                "
                >Pesquisar Insumo</b-button
              >
            </b-input-group-append>
          </b-input-group>

          <b-form-group
            id="input-group-1"
            label="Insumo"
            label-for="input-1"
            :description="
              estoque.insumo !== undefined
                ? `Insumo selecionado: ${estoque.insumo.codigo} - ${
                    estoque.insumo.descricao
                  } - ${estoque.insumo.unidade} `
                : ''
            "
          >
            <b-form-select
              id="input-1"
              v-model="estoque.insumo"
              type="text"
              class="input-color"
            >
              <b-form-select-option
                v-for="insumo in insumos"
                :key="insumo._id"
                :value="insumo"
              >
                {{ `${insumo.codigo} - ${insumo.descricao}` }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group
            id="input-group-4"
            label="Selecione uma Obra"
            label-for="input-5"
          >
            <!-- {{obras}} -->
            <b-form-select
              id="input-5"
              v-model="estoque.obra"
              class="input-color"
              type="text"
              placeholder="Enter items"
              required
            >
              <b-form-select-option
                v-for="obra in obras"
                :key="obra._id"
                :value="obra"
              >
                {{ obra.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <!-- <b-form-group
            v-if="isUpdating"
            id="input-group-1"
            label="Tipo"
            label-for="input-1"
          >
            <b-form-select
              id="input-1"
              v-model="estoque.tipo"
              class="input-color"
              type="text"
              placeholder="testando muito"
              :options="tipos"
              required
            ></b-form-select>
          </b-form-group> -->

          <b-form-group
            id="input-group-1"
            label="Quantidade"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="estoque.qtde"
              class="input-color"
              type="text"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-1"
            label="Valor unitário"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model.lazy="estoque.valor_unitario"
              v-money="money"
              class="input-color"
              type="text"
              required
            />
          </b-form-group>

          <b-form-group
            v-if="estoque.insumo"
            label="Unidade"
            label-for="input-unit"
          >
            <b-form-select
              id="input-unit"
              v-model="estoque.insumo.unidade"
              class="input-color"
              @change="setUnitAndQuantity(estoque.insumo)"
            >
              <b-form-select-option
                v-for="unit in units"
                :key="unit._id"
                :value="unit.nome"
              >
                {{ unit.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group
            v-if="estoque.insumo"
            label="Estoque Mínimo (corresponde a 30% do estoque total)"
            label-for="input-minimum-stock"
          >
            <b-form-input
              id="input-minimum-stock"
              :value="Math.round(estoque.qtde * 0.3) || 0"
              class="input-color"
              style="cursor: not-allowed;"
              :disabled="true"
            />
          </b-form-group>

          <b-form-group
            label="Pedido ou Contrato"
            label-for="input-order-or-contract"
          >
            <b-form-input
              id="input-order-or-contract"
              v-model="estoque.pedidoContrato"
              class="input-color"
            />
          </b-form-group>

          <b-form-group label="Nº. Nota Fiscal" label-for="input-nf">
            <b-form-input
              id="input-nf"
              v-model="estoque.notaFiscal"
              class="input-color"
            />
          </b-form-group>

          <b-form-group label="Descrição" label-for="input-descricao">
            <b-form-input
              id="input-descricao"
              v-model="estoque.descricaoStock"
              class="input-color"
            />
          </b-form-group>

          <b-form-group label="Data de Vencimento" label-for="input-vencimento">
            <b-form-input
              id="input-vencimento"
              v-model="estoque.dataVencimento"
              type="date"
              class="input-color"
            />
          </b-form-group>

          <b-form-group
            id="input-group-2"
            label="Observação"
            label-for="input-2"
          >
            <b-form-textarea
              id="input-2"
              v-model="estoque.obs"
              class="input-color"
              placeholder="Observação"
            ></b-form-textarea>
          </b-form-group>

          <b-button type="submit" variant="primary">Salvar</b-button>
        </b-form>
      </b-tab>
      <b-tab title="Importação" @click="changeTabSelected('import')">
        <div v-if="tabSelected === 'import'">
          <div class="row">
            <div class="col-6">
              <b-button variant="primary" @click="reset"
                >Resetar upload</b-button
              >
              <b-link
                class="ml-3"
                href="/importacao/modelo_importacao_estoque_cfobras.xlsx"
                >Modelo de planilha de importação</b-link
              >
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <vue-dropzone
                id="dropzone"
                ref="uploadEstoque"
                :options="dropzoneOptions"
                :use-custom-slot="true"
                @vdropzone-success="vsuccess"
                @vdropzone-sending="vsending"
                @vdropzone-error="verror"
              >
                <div class="text-center">
                  <i class="h1 text-muted uil-cloud-upload"></i>
                  <h3>Selecione o arquivo para importação de estoque.</h3>
                  <span class="text-muted font-size-13">
                    (O arquivo deve ter no máximo 3MB e seguir o padrão CF
                    Obras.)
                  </span>
                </div>
              </vue-dropzone>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import alertMixin from '@/src/mixins/alertMixin'
import serviceObra from '@/src/services/serviceObra'
import InsumoService from '@/src/services/serviceInsumoObra'
import UnitService from '@/src/services/unidadesObras'
import vue2Dropzone from 'vue2-dropzone'
import axios from 'axios'

import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  components: { vueDropzone: vue2Dropzone },
  mixins: [alertMixin],
  props: {
    // isUpdating: {
    //   type: Boolean,
    //   default: false,
    // },
    estoque: {
      type: Object,
      require: true,
      default: () => {},
      insumo: {},
    },
    salvar: {
      type: Function,
      default: () => {},
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      minStock: 0,
      value: '',
      tabSelected: 'stock',
      codigoInsumo: '',
      tipos: ['saida', 'entrada'],
      texto: '',
      obras: [],
      insumos: [],
      units: [],
      tipoPesquisa: 'codigo',
      dropzoneOptions: {
        url: `${axios.defaults.baseURL}/estoque/import`,
        thumbnailWidth: 150,
        timeout: 100000,
        maxFilesize: 1,
        maxFiles: 1,
        headers: {
          Authorization: this.$store.state.auth.currentUser.access_token,
        },
        acceptedFiles: '.xls,.xlsx',
        addRemoveLinks: true,
        dictRemoveFile: 'Remover arquivo',
      },
    }
  },
  async created() {
    await Promise.all([this.listaObra(), this.getAllUnits()])
  },
  methods: {
    async getAllUnits() {
      const {
        data: { data },
      } = await UnitService.list()

      this.units = data
    },
    setUnitAndQuantity(rawMaterial) {
      if (
        !this.estoque.qtde ||
        this.estoque.qtde === '' ||
        this.estoque.qtde.length === 0
      ) {
        // eslint-disable-next-line vue/no-mutating-props
        this.estoque.qtde = rawMaterial.estoqueBaixo
      }
    },
    changeTabSelected(tab) {
      this.tabSelected = tab
    },
    vsuccess(file, response) {
      this.setLoading(true)

      this.warningMessage(
        'Arquivo enviado com sucesso, o processo de importação pode levar algum tempo até ser concluído!'
      )

      const { data } = response

      if (data && data.length) {
        let msg = ''

        for (let a of data) {
          msg += `<br>${a}`
        }

        const h = this.$createElement
        const msgVNode = h('div', {
          domProps: {
            innerHTML: `${msg}<br>`,
          },
        })

        const title =
          'A importação de estoque não foi bem-sucedida devido os seguintes erros:'

        this.showMsgBox(msgVNode, title)
      }

      this.setLoading(false)
      this.reset()
    },
    vsending(file, xhr, formData) {
      this.setLoading(true)
    },
    verror(file) {
      this.setLoading(false)
      this.errorMessage(
        'Não foi possível importar o arquivo, por favor verifique se o arquivo enviado esta de acordo com o PADRÂO CF Obras.'
      )
    },
    reset() {
      this.$refs.uploadEstoque.removeAllFiles()
    },
    async listaObra() {
      this.setLoading(true)
      try {
        let {
          data: { data },
        } = await serviceObra.list(
          this.$store.state.filter,
          this.$store.state.filial
        )
        this.obras = data

        if (
          this.estoque.obra !== undefined &&
          this.estoque.obra._id !== undefined
        ) {
          let exitItem = this.obras.find(
            (el) => el._id === this.estoque.obra._id
          )
          if (exitItem !== undefined) this.estoque.obra = exitItem
        }
        this.setLoading(false)
      } catch (error) {
        this.setLoading(false)
        this.errorMessage('Erro ao Buscar Obras')
      }
    },
    async pesquisarInsumoId(codigo) {
      this.setLoading(true)
      let { data: resultado } = await InsumoService.buscaCodigo(
        codigo,
        null,
        this.$store.state.filter,
        this.$store.state.filial
      )
        .catch(() => {
          this.errorMessage('Erro ao Buscar Insumo')
        })
        .finally(() => {
          this.setLoading(false)
        })
      if (
        resultado.data.subItens !== undefined &&
        resultado.data.subItens.length > 0
      ) {
        this.insumos = resultado.data.subItens
        this.insumos.unshift(resultado.data)
        return
      }

      this.insumos = [resultado.data]
    },
    async pesquisarInsumoNome(nome) {
      this.setLoading(true)
      try {
        const { data: resultado } = await InsumoService.buscaNome(
          nome,
          this.$store.state.filter,
          this.$store.state.filial
        )
        this.setLoading(false)
        if (resultado.data === undefined) {
          this.errorMessage('Erro ao Buscar Insumo')
          return
        }
        if (
          resultado.data.subItens !== undefined &&
          resultado.data.subItens.length > 0
        ) {
          this.insumos = resultado.data.subItens
          this.insumos.unshift(resultado.data)
          return
        }

        this.insumos = [resultado.data]
      } catch (error) {
        this.errorMessage(
          `Erro ao buscar Insumo: ${error.response.data.error.message}`
        )
      } finally {
        this.setLoading(false)
      }
    },
  },
}
</script>
<style scoped>
.input-color {
  background-color: rgba(78, 78, 199, 0.212);
}
</style>
